export const TILE_ASSET_SIZE = {
    mobile: {
        grid3: 300,
        grid2: 500,
        full: 500,
        horizontal: 500,
        wishlist: 500,
        shoptheimage: 300,
    },
    tablet: {
        grid3: 320,
        grid2: 490,
        full: 600,
        horizontal: 780,
        wishlist: 490,
        shoptheimage: 320,
    },
    desktop: {
        grid3: 900,
        grid2: 1000,
        full: 1230,
        horizontal: 1600,
        wishlist: 900,
        shoptheimage: 900,
    },
}
